import WorkshopRegistrationForm from './WorkshopRegistrationForm';

export default WorkshopRegistrationForm;
